import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import moment from "moment";

import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";

// Vision UI Dashboard React components
import VuiTypography from "components/VuiTypography";
import VuiBox from "components/VuiBox";
import VuiProgress from "components/VuiProgress";
import VuiInfoItemLink from "components/VuiInfoItemLink";
import VuiLabel from "components/VuiLabel";
import VuiLoading from "components/VuiLoading";

import api from "services/api";

//
import breakpoints from "assets/theme/base/breakpoints";
import { navbarIconButton } from "examples/Navbars/DashboardNavbar/styles";
import useWindowDimensions from "hooks/useWindowDimensions";

import colors from "assets/theme/base/colors";

import SearchItem from "../SearchItem";

const INFO_TABLE_GRID = 0;
const INFO_TABLE_LIST = 1;

const ButtonIconItem = ({ name = "person", fontSizeIcon = "32px", onClick }) => {
  return (
    <IconButton
      size="small"
      color="inherit"
      sx={navbarIconButton}
      variant="contained"
      onClick={onClick}
    >
      <Icon fontSize={fontSizeIcon}>{name}</Icon>
    </IconButton>
  );
};

// function matchWildcard(pattern, value) {
//   const regex = new RegExp(
//     "^" + pattern.replace(/[.+?^${}()|[\]\\]/g, "\\$&").replace(/\*/g, ".*") + "$",
//     "i"
//   );

//   return regex.test(value);
// }

function matchWildcard(pattern, value) {
  const regexPattern =
    "^" +
    pattern
      .replace(/[.+^${}()|[\]\\]/g, "\\$&")
      .replace(/\*/g, ".*")
      .replace(/\?/g, ".") +
    "$";

  return new RegExp(regexPattern, "i").test(value);
}

function Links() {
  const { height, width } = useWindowDimensions();
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [rowsInit, setRowsInit] = useState([]);

  const [refreshInterval, setRefreshInterval] = useState(60000);
  const [countOffLines, setCountOfflines] = useState(0);
  const [countOnLines, setCountOnlines] = useState(0);
  const [countAllUnits, setCountAllUnits] = useState(0);
  const [filterActive, setFilterActive] = useState(false);
  const [pages, setPages] = useState(1);
  const [limit, setLimit] = useState(30);

  const [toogleInfo, setToogleInfo] = useState(INFO_TABLE_GRID);

  const [mobileNavbar, setMobileNavbar] = useState(false);
  const [mobileView, setMobileView] = useState(false);

  const { search } = useLocation();
  const actionCommand = search.replace("?", "").split("=")[0];
  const actionExec = search.replace("?", "").split("=")[1];

  async function loadLinks() {
    const data = [];
    const res = await api.get("links");

    res.data.map((x) => {
      if (x.enabled) {
        data.push({
          ...x,
          ip: x.gateway,
          status: x.laststatus,
          stage: x.hops,
          ttl: x.max,
          updatedAt: x.laststatus
            ? moment().format("DD/MM/YYYY HH:mm:ss")
            : moment(x.updatedAt).format("DD/MM/YYYY HH:mm:ss"),
          lastUpdatedAt: moment().format("DD/MM/YYYY HH:mm:ss"),
        });
      }
    });

    data
      .sort((a, b) => {
        if (a.ttl > b.ttl) {
          return -1;
        }
        if (a.ttl < b.ttl) {
          return 1;
        }
        return 0;
      })
      .sort((a, b) => Number(a.status) - Number(b.status));

    const countOfflines = data.filter((x) => !x.status).length;
    const countOnlines = data.filter((x) => x.status).length;
    const countAllLinks = data.length;

    setCountOfflines(countOfflines);
    setCountOnlines(countOnlines);
    setCountAllUnits(countAllLinks);

    // console.log(">>> data:", JSON.stringify(data));
    // console.log(">>> Search:actionCommand:", actionCommand, "- Search:actionExec:", actionExec);

    if (actionCommand === "search" && actionExec === "offline") {
      setRows(data.filter((x) => !x.status));
    } else if (actionCommand === "search" && actionExec === "online") {
      setRows(data.filter((x) => x.status));
    } else if (
      actionCommand === "search" &&
      (actionExec !== "online" || actionExec !== "offline")
    ) {
      if (actionExec !== "") {
        if (actionExec.search("%") > 0) {
          // console.log(">>> actionExec:", actionExec);
          const newData = data
            .filter(
              (x) =>
                x.initials.substring(0, actionExec.length - 1).toUpperCase() ===
                actionExec.substring(0, actionExec.length - 1).toUpperCase()
            )
            .sort((a, b) => {
              if (a.ip > b.ip) {
                return 1;
              }
              if (a.ip < b.ip) {
                return -1;
              }
              return 0;
            });

          // console.log(">>> newData:", newData);

          setRows(newData);
          setRowsInit(newData);
        } else {
          setRows(data.filter((x) => x.initials === actionExec.toUpperCase()));
          setRowsInit(data);
        }
      } else {
        setRows(data);
        setRowsInit(data);
      }
    } else {
      setRows(data);
      setRowsInit(data);
    }

    setLoading(false);
  }

  useEffect(() => {
    loadLinks();
  }, [false]);

  useEffect(() => {
    if (refreshInterval && refreshInterval > 0) {
      const interval = setInterval(loadLinks, refreshInterval);
      return () => clearInterval(interval);
    }
  }, [refreshInterval]);

  useEffect(() => {
    // A function that sets the display state for the DefaultNavbarMobile.
    function displayMobileNavbar() {
      if (window.innerWidth < breakpoints.values.lg) {
        console.log(">>> mobileView .....:", true);
        console.log(">>> mobileNavbar ...:", false);

        setMobileView(true);
        setMobileNavbar(false);
      } else {
        setMobileView(false);
        setMobileNavbar(false);
      }
    }

    /** 
       The event listener that's calling the displayMobileNavbar function when 
       resizing the window.
      */
    window.addEventListener("resize", displayMobileNavbar);

    // Call the displayMobileNavbar function to set the state with the initial value.
    displayMobileNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", displayMobileNavbar);
  }, []);

  return (
    <Card
      sx={{
        height: "100% !important",
      }}
    >
      <VuiBox
        sx={{
          "& th": {
            borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
              `${borderWidth[1]} solid ${grey[700]}`,
          },
          "& .MuiTableRow-root:not(:last-child)": {
            "& td": {
              borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                `${borderWidth[1]} solid ${grey[700]}`,
            },
          },
        }}
      >
        {loading ? (
          <VuiLoading />
        ) : (
          <VuiBox>
            <div
              style={{
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                fontSize: 24,
                marginBottom: 20,
              }}
            >
              <VuiLabel
                title={`Total de ${countAllUnits} Links Instalados e Monitorando`}
                sizeTitle={"24px"}
                colorTitle="warning"
              />

              {/* <div style={{ textAlign: "right", color: colors.warning.focus }}>
                Total de Unidades {countAllUnits} ativas
              </div> */}

              <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end" }}>
                {countOffLines > 0 ? (
                  <VuiLabel
                    title={`${
                      countOffLines > 0 && countOffLines < countAllUnits
                        ? ((countOffLines / countAllUnits) * 100).toFixed(2)
                        : 100
                    }%`}
                    colorTitle={"warning"}
                    sizeTitle={18}
                    subtitle="&nbsp;Offline"
                    colorSubTitle="error"
                    sizeSubTitle={18}
                  />
                ) : (
                  <>
                    <div style={{ textAlign: "right", color: colors.success.focus }}>100%</div>
                    <div
                      style={{ fontWeight: "bold", textAlign: "right", color: colors.success.main }}
                    >
                      Online
                    </div>
                  </>
                )}
              </div>

              <VuiProgress
                value={(countOffLines / countAllUnits) * 100}
                color="error"
                label={false}
              />

              {mobileView ? null : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    color: "white",
                    marginTop: 10,
                  }}
                >
                  {toogleInfo === INFO_TABLE_GRID ? (
                    <>
                      <SearchItem
                        onClick={async (text, filter) => {
                          let filterRows = [];
                          if (filter === "laststatus" && text === "online") {
                            filterRows = rows.filter((x) => matchWildcard(text, x[filter]));
                          } else {
                            filterRows = rows.filter((x) => matchWildcard(text, x[filter]));
                            console.log(`>>> ${text}:${filter}:`, filterRows);
                            setFilterActive(true);
                          }

                          if (filterRows.length === 0) {
                            setRows(rowsInit);
                          } else {
                            setRows(filterRows);
                          }
                        }}
                        onReset={() => {
                          setRows(rowsInit);
                          setFilterActive(false);
                        }}
                      />
                    </>
                  ) : (
                    <div>
                      <div></div>
                    </div>
                  )}

                  <VuiTypography
                    variant="lg"
                    display="flex"
                    flexDirection="row"
                    justifyContent="flex-end"
                    alignItems="center"
                    color="white"
                    p={"10px"}
                  >
                    <ButtonIconItem
                      name="grid_view"
                      onClick={() => {
                        setToogleInfo(INFO_TABLE_GRID);
                      }}
                    />

                    <div style={{ width: 5 }} />

                    <ButtonIconItem
                      name="list_view"
                      onClick={() => {
                        setToogleInfo(INFO_TABLE_LIST);
                      }}
                    />
                  </VuiTypography>
                </div>
              )}
            </div>

            {toogleInfo === INFO_TABLE_GRID ? (
              <Box sx={{ flexGrow: 2 }}>
                <Grid container spacing={{ xs: 1, md: 1 }} columns={{ xs: 3, sm: 6, md: 18 }}>
                  {rows.map((item, index) => {
                    return (
                      <Grid item xs={6} sm={6} md={6} key={index}>
                        <VuiInfoItemLink item={item} index={index} />
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>
            ) : null}
          </VuiBox>
        )}
      </VuiBox>
    </Card>
  );
}

export default Links;
